import React from 'react';
import { Modal, Form, Input, Button, Space, Alert, Select, Switch, InputNumber, Grid } from 'antd';

const { Option } = Select;
const { useBreakpoint } = Grid;

const TaxModal = ({ 
  visible, 
  onCancel, 
  onFinish, 
  form, 
  selectedTax, 
  selectedCompany,
  taxCatalogs,
  loading 
}) => {
  const screens = useBreakpoint();
  return (
    <Modal
      title={selectedTax ? 'Editar Impuesto' : 'Nuevo Impuesto'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={screens.xs ? '100%' : 600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Alert
          message="Información"
          description={`Este impuesto se asociará a la empresa: ${selectedCompany?.tax_name} - ${selectedCompany?.tax_id}`}
          type="info"
          showIcon
          style={{ marginBottom: '16px' }}
        />

        <Form.Item
          name="tax_code"
          label="Código de Impuesto"
          rules={[{ required: true, message: 'El código de impuesto es requerido' }]}
        >
          <Select placeholder="Selecciona el código de impuesto" showSearch>
            {taxCatalogs.tax_codes && Object.entries(taxCatalogs.tax_codes).map(([code, name]) => (
              <Option key={code} value={code}>
                {code} - {name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="tax_name"
          label="Nombre del Impuesto"
          rules={[{ required: true, message: 'El nombre del impuesto es requerido' }]}
        >
          <Input placeholder="Nombre del impuesto" />
        </Form.Item>

        <Form.Item
          name="tax_type"
          label="Tipo de Impuesto"
          rules={[{ required: true, message: 'El tipo de impuesto es requerido' }]}
        >
          <Select placeholder="Selecciona el tipo">
            <Option value="traslado">Traslado</Option>
            <Option value="retencion">Retención</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="tipo_factor"
          label="Tipo de Factor"
          rules={[{ required: true, message: 'El tipo de factor es requerido' }]}
        >
          <Select placeholder="Selecciona el tipo de factor">
            <Option value="Tasa">Tasa</Option>
            <Option value="Cuota">Cuota</Option>
            <Option value="Exento">Exento</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="tasa_o_cuota"
          label="Tasa o Cuota"
          rules={[{ required: true, message: 'La tasa o cuota es requerida' }]}
        >
          <InputNumber
            placeholder="0.16"
            min={0}
            max={1}
            step={0.01}
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          name="is_active"
          label="Estado"
          valuePropName="checked"
          initialValue={true}
        >
          <Switch 
            checkedChildren="Activo" 
            unCheckedChildren="Inactivo" 
          />
        </Form.Item>

        <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
          <Space>
            <Button onClick={onCancel}>
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {selectedTax ? 'Actualizar' : 'Crear'} Impuesto
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TaxModal;